import * as Sentry from '@sentry/react';

import { RUNTIME_ENV } from '../envConfig';

Sentry.init({
  dsn: 'https://60645459cb8720a1cd645aac397cd5c2@o322377.ingest.us.sentry.io/4509286103580672',
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: RUNTIME_ENV,
  beforeSend: event => {
    if (RUNTIME_ENV !== 'localdev') {
      return event;
    }
    return null;
  },
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export const SentryErrorBoundary = Sentry.ErrorBoundary;
